import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { blue } from '@material-ui/core/colors';
import Slide from '@material-ui/core/Slide';
import classNames from 'classnames';

import Question from './Question';
import AAPlayerWrapper from './AAPlayerWrapper';
import Feedback from './Feedback';

const styles = (theme) => ({
	root: {
		overflow: 'hidden'
	},
	hidden: {
		display: 'none'
	},
	answerContainer: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'row',
		margin: `0 ${theme.spacing.unit * 4}px ${theme.spacing.unit * 4}px`,
	},
	correctAnswer: {
		padding: `0 ${theme.spacing.unit * 2}px`,
		display: 'flex',
		justifyContent: 'center',
		whiteSpace: 'nowrap',
		color: 'white',
		backgroundColor: blue[500],
		flexDirection: 'column'
	},
	triangle: {
		borderWidth: 21,
		borderColor: 'transparent',
		borderLeftColor: blue[500],
		borderStyle: 'solid'
	}
});

class Item extends Component {
	render() {
		const { classes, index, visible, text, answered, audioPrefix, audioEnabled, basePath } = this.props;

		return (
			<div className={classNames(classes.root, { [classes.hidden]: !visible })}>
				<Slide direction="right" timeout={answered ? 0 : 300} in={visible}>
					<Question text={text} />
				</Slide>
				<AAPlayerWrapper itemIndex={index} listenUrl={audioEnabled ? `${basePath}audio/${audioPrefix}1.mp3` : null} />
				<Feedback answered={answered} />
			</div>
		);
	}
}

Item.propTypes = {
	classes: PropTypes.object.isRequired,
	text: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
	visible: PropTypes.bool.isRequired,
	answered: PropTypes.bool.isRequired,
	audioPrefix: PropTypes.string.isRequired,
	audioEnabled: PropTypes.bool.isRequired,
	basePath: PropTypes.string.isRequired,
};

function mapStateToProps({
	exercise: { currentItem, questionsAnswered, itemsMarkedText, audioPrefix, audioEnabled, log },
	loader: { testMode, testSent, basePath }
}, ownProps) {
	const answered = Boolean(questionsAnswered[ownProps.index] === true) || testSent;
	let text = ((!testMode || testSent) && Boolean(itemsMarkedText[ownProps.index] !== undefined)) ? itemsMarkedText[ownProps.index] : ownProps.text;
	text = text.replace(/\(-\)/g, '<br>');
	return {
		text,
		visible: currentItem === ownProps.index,
		answered,
		audioPrefix,
		audioEnabled,
		basePath,
		showAnswer: answered && (!testMode || testSent),
		log
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(Item);
